import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Login from "./pages/Login";
import Teams from "./pages/Teams";
import Playbook from "./pages/Playbook";
import Studio from "./pages/Studio";
import Home from "./pages/Home";

function Protected({ children }) {
  const { user, ready } = useAuth();
  if (!ready) {
    return (
      <div className="h-screen w-screen flex items-center justify-center bg-background">
        <div className="font-mono2 text-primary text-sm tracking-widest animate-pulse">LOADING TACTICS…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App dark">
      <AuthProvider>
        <BrowserRouter>
          <Toaster theme="dark" position="top-center" richColors />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Home />} />
            <Route path="/teams" element={<Protected><Teams /></Protected>} />
            <Route path="/drills/*" element={<Protected><Navigate to="/teams" replace /></Protected>} />
            <Route path="/team/:teamId" element={<Protected><Playbook /></Protected>} />
            <Route path="/team/:teamId/planner" element={<Protected><Navigate to=".." relative="path" replace /></Protected>} />
            <Route path="/studio/:playId" element={<Protected><Studio /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
